import DestinationRoutes from "./destination";
import QueryContainerRoutes from "./query_container";

export default [
    ...DestinationRoutes,
    ...QueryContainerRoutes
]
